import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { setAndSavePreviousFilterPanelVisibility, setFromPreviousFilterPanelVisibilty } from '../../actions/DisplaySettingsActions';
import { MapDispatchToProps } from '../../utils/ConnectUtils';

export type ShowFilterPanelInitiallyDispatchProps = {
  readonly setAndSavePreviousFilterPanelVisibility: (showFilterPanel: boolean) => void;
  readonly setFromPreviousFilterPanelVisibilty: () => void;
};

/**
 * Wraps an Explorer component with Redux actions that cause the filter panel to start in the visible state,
 * but only for this page. The filter panel visibility can still be toggled within this explorer, but it will
 * use its previous state when the user navigates to a different page.
 * (Note: remembering previous state is currently not working as expected; see TFS 913179)
 */
class ShowFilterPanelInitially extends React.Component<ShowFilterPanelInitiallyDispatchProps> {

  public componentWillUnmount() {
    this.props.setFromPreviousFilterPanelVisibilty();
  }

  public componentDidMount() {
    this.props.setAndSavePreviousFilterPanelVisibility(true);
  }

  public render() {
    return this.props.children;
  }
}

const mapDispatchToProps: MapDispatchToProps<ShowFilterPanelInitiallyDispatchProps> = (dispatch) => bindActionCreators({
  setAndSavePreviousFilterPanelVisibility,
  setFromPreviousFilterPanelVisibilty,
}, dispatch);

export const ConnectedShowFilterPanelInitially: React.ComponentType<{}> =
    connect(undefined, mapDispatchToProps)(ShowFilterPanelInitially);
